var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 38,
    height: 36.118,
    viewBox: "0 0 38 36.118",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "sydney-opera-house",
    transform: "translate(0 -12.676)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_765",
    "data-name": "Group 765",
    transform: "translate(0 12.676)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2415",
    "data-name": "Path 2415",
    d: "M37.362,28.722,34.152,25.8V16.1a1.118,1.118,0,0,0-1.118-1.118H25.307A1.118,1.118,0,0,0,24.189,16.1v.622l-3.877-3.533a1.94,1.94,0,0,0-2.625,0L.638,28.722a1.949,1.949,0,0,0,1.313,3.389H4.674V47.676a1.118,1.118,0,0,0,1.118,1.118h9.345a1.118,1.118,0,0,0,1.118-1.118V38.226h5.492v9.451a1.118,1.118,0,0,0,1.118,1.118h9.345a1.117,1.117,0,0,0,1.117-1.118V32.111h2.724a1.949,1.949,0,0,0,1.312-3.389Zm-5.153,1.154a1.118,1.118,0,0,0-1.118,1.118V46.559h-7.11V37.108a1.118,1.118,0,0,0-1.118-1.118H15.136a1.118,1.118,0,0,0-1.118,1.118v9.451H6.909V30.994a1.118,1.118,0,0,0-1.118-1.118H2.69L19,15.015l5.554,5.061a1.117,1.117,0,0,0,1.87-.826V17.216h5.492v9.075a1.117,1.117,0,0,0,.365.826l3.028,2.759Z",
    transform: "translate(0 -12.676)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg1);
export default __webpack_public_path__ + "static/media/1.2e22c4b96a03bce4c12e913ec4e543a1.svg";
export { ForwardRef as ReactComponent };